import { render, staticRenderFns } from "./SyncRules.vue?vue&type=template&id=005e2f0c&scoped=true"
import script from "./SyncRules.vue?vue&type=script&setup=true&lang=ts"
export * from "./SyncRules.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./SyncRules.vue?vue&type=style&index=0&id=005e2f0c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "005e2f0c",
  null
  
)

export default component.exports